import {Pipe, PipeTransform} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';

@Pipe({name: 'highlight'})
export class HighlightPipe implements PipeTransform {
  transform(value: string, searchTerm: string, highlightClass: string = 'bg-yellow-400 rounded'): SafeHtml {
    if (!value || !searchTerm) return value;

    const escapedTerm = searchTerm.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

    const regex = new RegExp(`(${escapedTerm})`, 'gi');
    return value.replace(regex, `<span class="${highlightClass}">$1</span>`);
  }
}
